import {EmployeeModel, IEmployeeModel} from "@/shared/model";
import {CheckBoxTreeNode} from "@/shared/ui";
import {z} from "zod";

const schema = z.object({
	employees: z.array(EmployeeModel.model).optional().default([])
});

const model = schema.transform((values) => ({
	...values,
	get tree(): CheckBoxTreeNode[] {
		function groupEmployeesToTree(employees: IEmployeeModel[]): CheckBoxTreeNode[] {
			const departmentMap: Record<string, CheckBoxTreeNode> = {};
			const rootNodes: CheckBoxTreeNode[] = [];

			employees.forEach((employee) => {
				if (employee.department === "부서 없음") {
					rootNodes.push({
						id: employee.externalId,
						name: `${employee.name} ${employee.position}`,
						tag: "MANAGER",
						value: false
					});
				} else {
					if (!departmentMap[employee.department]) {
						departmentMap[employee.department] = {
							id: employee.department,
							name: employee.department,
							tag: "DEPARTMENT",
							value: false,
							children: []
						};
					}

					// biome-ignore lint/style/noNonNullAssertion: <explanation>
					departmentMap[employee.department].children!.push({
						id: employee.externalId,
						name: `${employee.name} ${employee.position}`,
						tag: "MANAGER",
						value: false
					});
				}
			});

			const sortedDepartments = Object.values(departmentMap);
			return [...rootNodes, ...sortedDepartments];
		}

		return groupEmployeesToTree(values.employees);
	}
}));

export const EmployeeAllResModel = {schema, model};
export type IEmployeeAllResModel = z.infer<typeof EmployeeAllResModel.model>;
export const DEFAULT_EMPLOYEE_ALL: IEmployeeAllResModel = {
	employees: [],
	tree: []
};
